import { DoodApiError } from '@shared/interfaces/error.interface';
import { BogofSuggestion } from '@core/services/api/bogof/bogof-api.service';

export interface BogofData {
  triggerProductId: string;
  suggestions: BogofSuggestion[];
}

export interface BogofState {
  data: BogofData | null;
  isLoaded: boolean;
  isLoading: boolean;
  hasError: boolean;
  error: DoodApiError | null;
}

export const BOGOF_STORE_KEY = 'Bogof';

export const BOGOF_STORE_INITIAL_STATE: BogofState = {
  data: null,
  isLoaded: false,
  isLoading: false,
  hasError: false,
  error: null,
};
